module.exports = __webpack_public_path__ + "img/icon-4.23ec4a8c.png";